module.exports = __webpack_public_path__ + "img/TD.bf4d340b.svg";